import type {ComputedRef} from 'vue';
import type {User} from '../index';

export function useSofieUser(): ComputedRef<User> {
  const {data} = useAuth();

  return computed(() => (data.value?.user ?? {}) as User);
}

export function useSofieUserWhenAuthenticated(): ComputedRef<User | undefined> {
  const {data} = useAuth();

  return computed(() => data.value?.user as User);
}
